// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"SetPassword_errorMessage__2c_q-","socialButtons":"SetPassword_socialButtons__fCtks","icon":"SetPassword_icon__YaKYT"};